import { Helmet } from 'react-helmet-async'

const BASE_URL = 'https://waithere.com.br'

export default function SEO({ title, description, path = '', type = 'website' }) {
  const fullTitle = title
    ? `${title} | WaitHere`
    : 'WaitHere — Cardápio digital, pedidos e site para seu restaurante'

  const desc =
    description ||
    'Crie o site do seu restaurante com cardápio digital, pedidos de mesa, delivery e retirada. Plano gratuito para sempre.'

  const url = `${BASE_URL}${path}`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:url" content={url} />
    </Helmet>
  )
}
